<div class="back-button" (click)="closeSubMenu()">
  <app-icon iconStyle="fal" iconType="fa" iconName="angle-left"></app-icon>
  <app-icon iconStyle="far" iconType="fa" iconName="bars"></app-icon>
</div>
<p-menu [model]="menuItems"></p-menu>
